module.exports = __webpack_public_path__ + "static/media/bryllupslogo_mobile_cropped.bd81fdc6.png";